// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"177":"home","656":"feedback"}[chunkId] + "." + {"177":"51e3ef76","656":"13e9ee68"}[chunkId] + ".js";
};